import type { FC } from 'react';
import React from 'react';

import type { FeedEventComment as CommentType } from '../../feedCardTypes';

import { Comment } from './Comment';

type CommentsProps = {
	comments: CommentType[];
	pageId?: string;
	contentType?: string;
};

export const Comments: FC<CommentsProps> = ({ comments, pageId, contentType }) => {
	return (
		<div data-testid="feed-card-comments">
			{comments.map((commentData) => {
				if (commentData?.comment) {
					return (
						<Comment
							key={commentData.comment.id}
							user={commentData.user}
							comment={commentData.comment}
							pageId={pageId}
							contentType={contentType}
						/>
					);
				}
				return null;
			})}
		</div>
	);
};
